<raf-section gutterBottom="none">
  <div class="tab-nav-wrap">
    <nav class="tab-nav">
      <ng-content></ng-content>
    </nav>
  </div>
</raf-section>
